<p-card>
    <div class="welcome">
        <!-- Columna izquierda con el texto y botón -->
        <div class="welcome-content">
            <div class="welcome-content align-items-start">
                <h3 style="font-weight: 100;">Paso 3</h3>
                <h1>Ya casi terminamos.</h1>
                <h3 style="font-weight: 100;">Agrega los últimos toques para que tu
                    propiedad destaque, revisa que todo esté en orden y ¡listo!.</h3>
            </div>
        </div>
        <!-- Columna derecha con las cartas apiladas -->
        <div class="welcome-images">
            <img class="image image-1" [src]="'assets/layout/images/home/1.png'" alt="Image 1">
            <img class="image image-2" [src]="'assets/layout/images/home/2.png'" alt="Image 2">
            <img class="image image-3" [src]="'assets/layout/images/home/3.png'" alt="Image 3">
        </div>
    </div>
    <app-page-navigation-bar [value]="65" [type]="'complete'"
                             [previousPageURL]="previousUrl"
                             [nextPageURL]="nextUrl"
                             [flowMode]="mode"
                             [stepKey]="'third'"
                             (goNext)="handleNextStep()"
                             (goPrevious)="handlePreviousStep()">
    </app-page-navigation-bar>
</p-card>
